import { CircleDot } from "../../../../../../../../assets/icons/CircleDot";

export function CustomPromsScatterDot(props: any) {
  const { fill, surveyId, onDotClick } = props;

  return (
    <CircleDot
      fill={fill}
      onClick={() => onDotClick ?? onDotClick(surveyId)}
      isProms
      {...props}
    />
  );
}
